<script lang="ts">
  import ProductForm from '../components/ProductForm.svelte';

  interface Props {
    params?: { id?: string };
  }
  let { params }: Props = $props();
</script>

{#key params?.id}
  <ProductForm productId={params?.id ?? null} />
{/key}
